import { ActionContext } from 'vuex';
import { BatchActions, Boards, Distribution, Postings } from 'src/api';
import { StateInterface } from 'src/store';
import { DistributionStateInterface } from 'src/store/distribution/state';

export function setExecutionRecords(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  records: Distribution.Types.Execution[]
) {
  context.commit('SET_EXECUTIONS', records);
  context.commit('loading/SET_EXECUTIONS_LOADING', false, { root: true });
}

export function addExecutionRecords(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  records: Distribution.Types.Execution[]
) {
  context.commit('ADD_EXECUTIONS', records);
}

export function setExecutionDayOffset(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  offset: number
) {
  context.commit('SET_EXECUTIONS_OFFSET', offset);
}

export function setBoards(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  boards: Boards.Types.Board[]
) {
  context.commit('SET_BOARDS', boards);
}

export function addBoards(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  boards: Boards.Types.Board[]
) {
  context.commit('ADD_BOARDS', boards);
}

export function setBoardsStatus(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  payload: { boardIds: number[]; status: boolean }
) {
  const boards = context.state.boards.reduce(
    (acc: Boards.Types.Board[], board) => {
      if (payload.boardIds.includes(board.id)) {
        acc.push({
          ...board,
          enabled: payload.status,
        });
      }
      return acc;
    },
    []
  );

  return context.commit('UPDATE_BOARDS', boards);
}

export function includeLocalOutreach(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  payload: boolean
) {
  context.commit('INCLUDE_LOCAL_OUTREACH', payload);
}

export function updateBoards(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  boards: Boards.Types.Board[]
) {
  context.commit('UPDATE_BOARDS', boards);
}

export function setPostings(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  postings: Postings.Types.Posting[]
) {
  context.commit('SET_POSTINGS', postings);
  context.commit('loading/SET_POSTINGS_LOADING', false, { root: true });
}

export function addPostings(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  postings: Postings.Types.Posting[]
) {
  context.commit('ADD_POSTINGS', postings);
}

export function setBoardBatchActionExecutions(
  context: ActionContext<DistributionStateInterface, StateInterface>,
  payload: BatchActions.Types.BatchActionExecutionRecord[]
) {
  context.commit('SET_BOARD_BATCH_ACTION_EXECUTIONS', payload);
}
